
var full_message = "";

export const sendAPI = async (messages_legacy, setStreamedText) => {
    full_message = "";
    console.log("GO");
    const openrouter_api_key = "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";

    // const question = 'How would you build the tallest building ever?';
    // const question = user_message;

    const response = await fetch('https://openrouter.ai/api/v1/chat/completions', {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${openrouter_api_key}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            // model: 'google/gemma-4-31b-it:free',
            model: 'nvidia/nemotron-3-nano-30b-a3b:free',
            // messages: [{ role: 'user', content: question }],
            messages: messages_legacy,
            temperature: 0,
            stream: true,
        }),
    });

    const reader = response.body?.getReader();
    if (!reader) {
        throw new Error('Response body is not readable');
    }
    const decoder = new TextDecoder();

    let buffer = '';

    try {
        while (true) {
            const { done, value } = await reader.read();
            if (done) break;
            // Append new chunk to buffer
            buffer += decoder.decode(value, { stream: true });
            // Process complete lines from buffer
            while (true) {
                const lineEnd = buffer.indexOf('\n');
                if (lineEnd === -1) break;
                const line = buffer.slice(0, lineEnd).trim();
                buffer = buffer.slice(lineEnd + 1);
                if (line.startsWith('data: ')) {
                    const data = line.slice(6);
                    if (data === '[DONE]') {
                        // return full_message;
                        break;
                    }
                    try {
                        const parsed = JSON.parse(data);
                        const content = parsed.choices[0].delta.content;
                        if (content) {
                            full_message = full_message + content;
                            console.log(content);
                            setStreamedText(full_message);
                        }
                    } catch (e) {
                        // Ignore invalid JSON
                    }
                }
            }
        }
    } finally {
        reader.cancel();
        console.log("----------------- OVER", full_message);
        return full_message
    }

}